import { render } from "./AppCourseTile.vue?vue&type=template&id=e00b25ac&ts=true"
import script from "./AppCourseTile.vue?vue&type=script&lang=ts"
export * from "./AppCourseTile.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/0/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__